var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tool-index arrow-options"},[_c('arrow-options-preview'),_c('arrow-options-selection'),_c('arrow-options-Color')],1)}
var staticRenderFns = []

export { render, staticRenderFns }